import { RouteRecordRaw } from 'vue-router';

const PositionOverview = () => import('@/modules/positions/pages/PositionsOverview.vue');

const PositionDetails = () => import('@/modules/positions/components/position-details/PositionDetails.vue');

const PositionDetailsPage = () => import('@/modules/positions/pages/PositionDetailsPage.vue');
const PositionDetailsPositionPage = () => import('@/modules/positions/pages/position-details/PositionDetailsPositionPage.vue');
const PositionDetailsProfilePage = () => import('@/modules/positions/pages/position-details/PositionDetailsProfilePage.vue');
const PositionDetailsActivitiesPage = () => import('@/modules/positions/pages/position-details/PositionDetailsActivitiesPage.vue');
const PositionDetailsPublicationsPage = () => import('@/modules/positions/pages/position-details/PositionDetailsPublicationsPage.vue');

const POSITION_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'PositionsOverview',
      component: PositionOverview,
      children: [
         {
            path: ':id',
            name: 'PositionDetail',
            component: PositionDetails,
         },
      ],
   },
   {
      path: 'details/:id',
      name: 'PositionOverviewDetails',
      component: PositionDetailsPage,
      redirect: { name: 'PositionDetailsPositionPage' },
      children: [
         {
            path: 'position',
            name: 'PositionDetailsPositionPage',
            component: PositionDetailsPositionPage,
            meta: {
               id: 1,
            },
         },
         {
            path: 'profile',
            name: 'PositionProfileDetailsPage',
            component: PositionDetailsProfilePage,
            meta: {
               id: 2,
            },
         },
         {
            path: 'activities',
            name: 'PositionActivitiesDetailsPage',
            component: PositionDetailsActivitiesPage,
            meta: {
               id: 3,
            },
         },
         {
            path: 'publications',
            name: 'PositionPublicationsDetailsPage',
            component: PositionDetailsPublicationsPage,
            meta: {
               id: 4,
            },
         },
      ],
   },
];

export { POSITION_ROUTES };
